module.exports = __webpack_public_path__ + "media/invite/cash-88af57c3.svg";